import { color } from "framer-motion"
import arrow from "./esalab/icons8-arrow-down-ios-17-outlined (1)/icons8-arrow-down-100.png"

export default function Navigtion(props){
    return <div key={props.admin} className="navigation">
        {props.admin?<a href="/registerEmp">Register New Employee</a>:null}
        <a href="/uploadReports">Upload Reports</a>
        <a href="/registerPatient">Register Patient</a>
        {props.admin?<a href="/checkBalance">Check Balance</a>:null}
    </div>
}